var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60156 0.825195C3.73756 0.825195 0.601562 3.9612 0.601562 7.8252C0.601562 11.6892 3.73756 14.8252 7.60156 14.8252C11.4656 14.8252 14.6016 11.6892 14.6016 7.8252C14.6016 3.9612 11.4656 0.825195 7.60156 0.825195ZM7.60156 12.0252C7.08823 12.0252 6.66823 11.6052 6.66823 11.0919C6.66823 10.5785 7.08823 10.1585 7.60156 10.1585C8.1149 10.1585 8.5349 10.5785 8.5349 11.0919C8.5349 11.6052 8.1149 12.0252 7.60156 12.0252ZM8.35756 8.52986L8.67023 4.7872C8.6749 4.7592 8.6749 4.72653 8.6749 4.69853C8.6749 4.11053 8.1989 3.6252 7.60156 3.6252C6.97156 3.6252 6.48156 4.16186 6.5329 4.7872L6.84556 8.52986C6.87823 8.92186 7.2049 9.22519 7.60156 9.22519C7.99823 9.22519 8.3249 8.92186 8.35756 8.52986Z",
    fill: "#FF6174"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.01ff77e325fe11a23a0a11b93df65791.svg";
export { ForwardRef as ReactComponent };